export const preNumberGreek = [
    {label: "Κενό", value: "noprefix"},
    {label: "A", value: "Α"},
    {label: "B", value: "B"},
    {label: "Γ", value: "Γ"},
    {label: "∆", value: "Δ"},
    {label: "E", value: "Ε"},
    {label: "Z", value: "Ζ"},
    {label: "H", value: "Η"},
    {label: "Θ", value: "Θ"},
    {label: "I", value: "Ι"},
    {label: "K", value: "Κ"},
    {label: "Λ", value: "Λ"},
    {label: "M", value: "M"},
    {label: "N", value: "N"},
    {label: "Ξ", value: "Ξ"},
    {label: "O", value: "O"},
    {label: "Π", value: "Π"},
    {label: "P", value: "P"},
    {label: "Σ", value: "Σ"},
    {label: "T", value: "T"},
    {label: "Υ", value: "Υ"},
    {label: "Φ", value: "Φ"},
    {label: "X", value: "X"},
    {label: "Ψ", value: "Ψ"},
    {label: "Ω", value: "Ω"},

    { label: "ΠΑ", value: "ΠΑ" },
    { label: "ΠΒ", value: "ΠΒ" },
    { label: "ΠΓ", value: "ΠΓ" },
    { label: "ΠΔ", value: "ΠΔ" },
    { label: "ΠΕ", value: "ΠΕ" },
    { label: "ΠΖ", value: "ΠΖ" },
    { label: "ΠΗ", value: "ΠΗ" },
    { label: "ΠΘ", value: "ΠΘ" },
    { label: "ΠΙ", value: "ΠΙ" },
    { label: "ΠΚ", value: "ΠΚ" },
    { label: "ΠΛ", value: "ΠΛ" },
    { label: "ΠΜ", value: "ΠΜ" },
    { label: "ΠΝ", value: "ΠΝ" },
    { label: "ΠΞ", value: "ΠΞ" },
    { label: "ΠΟ", value: "ΠΟ" },
    { label: "ΠΠ", value: "ΠΠ" },
    { label: "ΠΡ", value: "ΠΡ" },
    { label: "ΠΣ", value: "ΠΣ" },
    { label: "ΠΤ", value: "ΠΤ" },
    { label: "ΠΥ", value: "ΠΥ" },
    { label: "ΠΦ", value: "ΠΦ" },
    { label: "ΠΧ", value: "ΠΧ" },
    { label: "ΠΨ", value: "ΠΨ" },
    { label: "ΠΩ", value: "ΠΩ" }
]

export const numberingModeOptions = [{
    value: 'automatic',
    label: 'Αυτόματη'
}, {
    value: 'manual',
    label: 'Χειροκίνητη'
}]
